import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ModuleState, ModuleMaster } from '../../types/module.types';

const initialState: ModuleState = {
  modules: [],
  loading: false,
  error: null,
};

const moduleSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    setModules: (state, action: PayloadAction<ModuleMaster[]>) => {
      state.modules = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setModules, setLoading, setError } = moduleSlice.actions;
export default moduleSlice.reducer;